// extracted by mini-css-extract-plugin
export var chip = "_bu-0";
export var filterDropdown = "_bu-5";
export var filterItem = "_bu-6";
export var icon = "_bu-1";
export var removeButton = "_bu-3";
export var removeIcon = "_bu-4";
export var separator = "_bu-2";